module.exports = __webpack_public_path__ + "img/vertical_6_6_5012.e746a6c7.png";